import { createRoutes, str, int } from '../typesafe-routes';
import { oldJsonParam } from './utils';

export const crmRoutes = createRoutes({
  users: {
    path: ['users'],
    query: [
      str.optional('tab'),
      int.optional('offset'),
      int.optional('limit'),
      oldJsonParam().optional('searchFilter'),
      oldJsonParam().optional('orderBy'),
      str.optional('userId'),
    ],
  },
});
